import React from "react";
import StateDetails from "../components/StateDetails";
import TopNav from "../components/TopNav";
import Sidebar from "../components/SideNav";
import Footer from "../components/Footer";

const StateDetailsPage = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div className="sticky-top z-3">
        <TopNav />
      </div>
      <div className="d-flex flex-grow-1 overflow-hidden">
        <aside
          style={{
            position: "sticky",
            height: "calc(100vh - 120px)",
          }} 
        >
          <Sidebar />
        </aside>
        <main className="w-100 overflow-auto">
          <StateDetails />
        </main>
      </div>
      <div className="sticky-bottom z-3">
        <Footer />
      </div>
    </div>
  );
};

export default StateDetailsPage;